/**
 * Rotate a circle text element on scroll
 * <div class="circle-text circle-text--example">
 *    <div class="circle-text__container">
 *       <svg class="circle-text__circle" width="260" height="260" viewBox="0 0 260 260" aria-hidden="true">
 *          <circle id="circle-text-path" cx="130" cy="130" r="94" fill="transparent" />
 *          <text width="200" fill="currentColor">
 *             <textPath xlink:href="#circle-text-path">
 *                Homebase • Homebase • Homebase • Homebase •
 *             </textPath>
 *          </text>
 *       </svg>
 *    </div>
 * </div>
 */
window.addEventListener("DOMContentLoaded", () => {
   const circleText = document.querySelector(".circle-text__circle");

   if (circleText) {
      const y = 100 / 360;

      window.addEventListener("scroll", () => {
         const x = 100 / document.body.offsetHeight * window.scrollY;

         if (circleText) {
            circleText.style.transform = `rotate(${y * x * 2.5}deg)`
         }
      });
   }
});
